var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulbIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 183",
    height: "2em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m63.5,1.72c-17.23,0-33.47,6.82-44.55,18.72-9.65,10.36-14.43,23.51-13.47,37.03l6.66,75.14h12.19v-7.56h-5.1l-6.21-68.11c-.81-11.4,3.26-22.53,11.46-31.33,9.66-10.36,23.88-16.31,39.01-16.31s29.36,5.94,39.01,16.31c8.2,8.81,12.27,19.93,11.46,31.33l-4.94,68.11h-5.17v7.56h12.07l5.58-75.14c.96-13.52-3.83-26.67-13.47-37.03C96.97,8.54,80.73,1.72,63.5,1.72Z",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m90.75,136.18h6.95v11.1H29.3v-11.1h6.95v4.76h54.5v-4.76Z",
    style: {
      fill: "#42c0b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.75,159.93v-4.76h6.95v11.1H29.3v-11.1h6.95v4.76h54.5Z",
    style: {
      fill: "#42c0b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.69,174.95v-4.4h6.95v10.74h-58.27v-10.74h6.95v4.4h44.37Z",
    style: {
      fill: "#42c0b7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "85.18 94.33 85.18 91.6 78.39 91.6 78.25 109.41 64.98 109.41 64.98 122.81 73.15 122.81 73.29 115.93 85.18 115.93 85.18 113.08 96.56 113.08 96.56 124.46 85.18 124.46 85.18 121.62 78.87 121.62 78.73 128.5 64.98 128.5 64.98 135.66 59.29 135.66 59.29 117.96 43.53 117.96 43.53 120.81 32.14 120.81 32.14 109.42 43.53 109.42 43.53 112.27 59.29 112.27 59.29 102.13 39.16 102.13 39.29 85.73 36.33 85.73 36.33 74.34 47.72 74.34 47.72 85.73 44.97 85.73 44.89 96.44 59.29 96.44 59.29 78.15 56.32 78.15 56.32 66.77 67.7 66.77 67.7 78.15 64.98 78.15 64.98 103.72 72.61 103.72 72.75 85.91 85.18 85.91 85.18 82.94 96.56 82.94 96.56 94.33 85.18 94.33",
    style: {
      fill: "#064860"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbIcon);
export default __webpack_public_path__ + "static/media/bulb-icon.5dae40aa12cd1488b1c716bb06974b78.svg";
export { ForwardRef as ReactComponent };